<template>
  <section class="section container pt-3">
    <instance-datatable ref="instance_datatable" />
  </section>
</template>

<script>
import InstanceDatatable from "./instance_datatable/Index.vue";

export default {
  name: "NgineWorkspaceIndex",
  components: { InstanceDatatable },
  data() {
    return {};
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    create() {
      console.log("create order");
    },
    refresh() {
      console.log("refresh orders");
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
